import Axios from "axios";
import store from "@/store";

// 请求拦截器;
Axios.interceptors.request.use(
  (config) => {
    store.commit("setErrApi", { type: false });
    config.headers["Authorization"] = "Bearer " + store.state.token;

    config.headers["SCHOOL-ID"] = store.state.schoolId;
    //app版本获取接口
    config.headers["platform"] = 1;
    let uuid = localStorage.getItem("alumni_uuid");
    if (uuid) {
      config.headers["X-Visitor-Uuid"] = uuid;
    }
    return config;
  },
  (err) => {
    return Promise.reject(err);
  }
);
//返回拦截器
Axios.interceptors.response.use(
  (response) => {
    // console.log("进入了正确的请求");
    // console.log(response);
    //拦截响应，做统一处理
    if (
      response.status != 401 &&
      response.status != 403 &&
      response.status != 200 &&
      response.status != 426 &&
      response.status != 302 &&
      response.status != 301
    ) {
      // console.log("jinle");
      store.commit("setErrApi", { type: true, text: "服务器内部错误!" });
      return Promise.reject(response);
    }
    if (response.status == 200) {
      if (response.data.code == 0) {
        Promise.resolve(response.data);
      }
      if (response.data.code == 1) {
        if (!response.data.msg) {
          store.commit("setErrApi", { type: true, text: "系统繁忙!" });
        } else {
          store.commit("setErrApi", { type: true, text: response.data.msg });
        }
        return Promise.reject(response);
      }
    } else {
      if (!response.data.msg) {
        store.commit("setErrApi", { type: true, text: "系统繁忙!" });
      } else {
        store.commit("setErrApi", { type: true, text: response.data.msg });
      }
      return Promise.reject(response);
      // Toast.fail(response.data.msg);
    }
    return response.data;
  },
  //接口错误状态处理，也就是说无响应时的处理
  (error) => {
    // console.log("进入了错误的请求");
    // Object.keys(error);
    // console.log(error);
    // if (error.response.data && !error.response.data.msg) {
    //   store.commit("setErrApi", { type: true, text: "系统繁忙!" });
    // } else {
    //   store.commit("setErrApi", { type: true, text: error.response.data.msg });
    // }
    store.commit("setErrApi", { type: true, text: "服务器内部错误!" });
    return Promise.reject(error.response.status); // 返回接口返回的错误信息
  }
);

export default Axios;
